<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
        <div slot="content">
            <div class="btn-type1">
                <el-button size="mini" type="primary" icon="el-icon-search" @click="goOpen">
                    {{ this.$i18n.messages[this.$store.state.locale].search }}
                </el-button>
            </div>
            <div class="pop-content-search">
                <el-form size="mini" label-width="65px">
                    <el-row>
                        <el-col :span="6">
                          <el-form-item label="제조사">
                            <el-select v-model="form.maker" >
                              <el-option value=''>==전체==</el-option>
                              <el-option
                                  v-for="item in combos['maker']"
                                  :key="item.value"
                                  :value="item.key"
                                  :label="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="18">
                          <el-row>
                            <el-form-item label="제품군" label-width="80px">
                              <el-col :span="12">
                                <el-select v-model="form.itemGroup" @change="onCatIdChange">
                                  <el-option value=''>==전체==</el-option>
                                  <el-option
                                      v-for="item in combos['itemGroup']"
                                      :key="item.key"
                                      :value="item.key"
                                      :label="item.value">
                                  </el-option>
                                </el-select>
                              </el-col>
                              <el-col :span="12">
                                <el-select v-model="form.subItemGroup" v-show="subItemGroupShow">
                                  <el-option value=''>==전체==</el-option>
                                  <el-option
                                      v-for="item in combos['subItemGroup']"
                                      :key="item.key"
                                      :value="item.key"
                                      :label="item.value">
                                  </el-option>
                                </el-select>
                              </el-col>
                            </el-form-item>
                          </el-row>
                        </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="6">
                        <el-form-item label="모델">
                          <el-input v-model="form.modelNm" @keyup.native.enter="goOpen"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="구분">
                          <el-input type="text" v-model="form.description" @keyup.native.enter="goOpen"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="품번">
                          <el-input v-model="form.itemCd" @keyup.native.enter="goOpen"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="품명">
                          <el-input v-model="form.itemNm" @keyup.native.enter="goOpen"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                </el-form>
            </div>

            <div class="table-area">
                <div class="table-b">
                    <ag-grid-vue 
                        style="width: 100%; height: 520px;"
                        class="ag-theme-alpine"    
                        row-selection="single"
                                
                        :column-defs="columnDefs"     
                        :grid-options="gridOptions"
                        :row-data="rowData"
                        :default-col-def="defaultColDef"
                        :statusBar="statusBar"
                        @rowDoubleClicked="rowDoubleClick"
                        @grid-ready="onGridReady"
                        @cell-clicked="onCellClicked" />
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';

/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


export default {
    props: {
      data: {
        Type: Array
        , required: false
      },
    },
    components: {Layout, AgGridVue},
    data() {
        return {
            title: '자재선택',
            form: {
              companyId : '',
              maker : '',             // 제조사
              itemGroup : '',         // 제품군
              subItemGroup: '',       // 제품군
              useModelNm : '',        // 모델명 (팝업에서 모델명 입력하지 않았을 경우 사용 )
              modelNm : '',           // 모델명 (팝업에서 모델명 입력했을 경우 사용 )
              description : '',       // 구분
              itemCd : '',            // 품번
              itemNm : '',            // 품명
              asAgentId : '',
              sortType : '',
              page : 1,
              totalPage : 99999,
              curPage : 0,
              totalCount : 99999,
              processTime : ''
            },

            // AG-GRID OPTION [START]
            rowData:[],
            columnDefs: [],
            gridOptions: {},
            subItemGroupShow : false,   /** sub제품군 여부**/
            combos: {
              'maker' : [],
              'itemGroup' : [],
              'subItemGroup' : [],
            },
            defaultColDef: {
                resizable: true,
                filter:true,
                sortable: true
            },
            statusBar: null
        }
    },
    mounted() {
      this.form.companyId = this.$store.state.loginInfo.compCd;
      this.getCombo();
      this.getConfigValue()
    },
    methods: {
      closeModal() {
        this.$parent.close();
      },
      onGridReady(){
        this.init();
      },
      createMainColumnDefs() {
        let that = this;
        this.columnDefs = [
          {headerName: '제조사', width:120, field:'makerNm', cellStyle:{textAlign:'center'}},
          {headerName: '제품군', width:120, field:'itemGroupNm', cellStyle:{textAlign:'center'}},
          {headerName: '품번', width:180, field:'itemCd'},
          {headerName: '모델', width:180, field:'modelNm', cellStyle:{textAlign:'left'}},
          {headerName: '품명', width:180, field:'itemNm', cellStyle:{textAlign:'left'}},
          {headerName: '규격', width:180, field:'itemSpec', cellStyle:{textAlign:'left'}},
          {headerName: '보유자재', width:130, field:'invtGoodQty', cellStyle:{textAlign:'left'}},
          {headerName: '운영단가', width:120, field:'unitPrice2', cellStyle:{textAlign:'right'},
            valueFormatter: (params) => {
              return that.chkNumber(params, '', '');
            }
          },
          {headerName: '소비자가', width:120, field:'unitPrice3', cellStyle:{textAlign:'right'},
            valueFormatter: (params) => {
              return that.chkNumber(params, '', '');
            }
          },
        ];
      },
      rowDoubleClick(params){
          this.$emit('close', params.data);
      },
      onCellClicked(params) {
          console.log('add onCellClicked  start===', params.data)
          this.$emit('close', params.data);
          this.closeModal();
      },
      getCombo() {
        this.getMakerCombo();
        this.getItemGroupCombo();
      },
      getConfigValue() {
        this.$http.get(`/api/config/keyPath/info`, {params: {keyPath: 'System.MainAsAgentId'}})
            .then(response => {
              this.form.asAgentId = response.data[0].configValue;
            });
      },
      getMakerCombo(){
        this.$http.get(`/api/codeMng/combo`, { params: {parentId: 196} })
            .then(response => {
              this.combos['maker'] = response.data || []
            });
      },
      getItemGroupCombo(){
        this.$http.get(`/api/codeMng/combo`, { params: {parentId: 143} })
            .then(response => {
              this.combos['itemGroup'] = response.data || []
            });
      },
      onCatIdChange(param){
        this.form.subItemGroup = '';
        if(param === '' ) this.subItemGroupShow =  false;
        else{
          this.subItemGroupShow =  true;
          this.$http.get(`/api/codeMng/detail`, { params: {parentId: 143} })  // 제품군
              .then(response => {
                let subData = response.data.filter(x => x.catKey === param);
                this.$http.get(`/api/codeMng/combo`, { params: {parentId: subData[0].catId} })
                    .then(response => {
                      this.combos['subItemGroup'] = response.data || []
                    });
              });
        }
      },
      async init() {
        this.$store.commit('loading');
        this.createMainColumnDefs();
        this.$store.commit('finish');
      },
      goOpen(){
        this.$store.commit('loading')
        let vForm = {
          companyId : this.form.companyId,
          maker : this.form.maker,                // 제조사
          itemGroup : (this.form.subItemGroup.length <= 0 || this.form.subItemGroup === '')  ? this.form.itemGroup : this.form.subItemGroup,     // 제품군
          modelGroup : (this.form.subItemGroup.length <= 0 || this.form.subItemGroup === '')  ? this.form.itemGroup : this.form.subItemGroup,     // 제품군
          useModelNm : this.form.useModelNm,       // 모델명
          modelNm : this.form.modelNm,            // 모델명
          description : this.form.description,    // 구분
          itemCd : this.form.itemCd,              // 품번
          itemNm : this.form.itemNm,              // 품명
          asAgentId : this.form.asAgentId,
          sortType : this.form.sortType,
          page : this.form.page,
          totalPage : this.form.totalPage,
          curPage : this.form.curPage,
          totalCount : this.form.totalCount,
          processTime : this.form.processTime,
          userId: this.$store.state.loginInfo.id
        }

        //모델 inputBox에 text 기입시 분기 처리 되어있음(as-is)
        let postUrl;
        if (this.form.modelNm === '') postUrl = "/api/workMng/mateEntering/popup/list";
        else postUrl = "/api/workMng/reqMateEnter/popup/list";

        this.$http.post((postUrl), vForm
        ).then(response => {
          this.rowData = response.data
        }).finally(() => {
          this.$store.commit('finish')
        });
      },
      chkNumber(params, flag, excRt){
        var result = '';
        var val = params.value;
        var data = this.data;

        if(flag === 'sub') data = this.subData;

        if(!_.isEmpty(val) || _.isNumber(val)){
          val = val.toString();

          if (excRt === 'excRt') result = this.$numeral(val).format('0,0.00');
          else result = this.$numeral(val).format('0,0');

          //data[params.node.id][params.column.colId] = this.$numeral(val).value();
        }

        return result
      },
    },
    created() {
      this.form.modelNm = this.data.modelNm;
      this.statusBar = {
        statusPanels: [
          { statusPanel: 'agTotalRowCountComponent', align: 'right' },
        ],
      };
    },
}
</script>

<style lang="scss" scoped>
</style>